import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../styles/About.css";

const About = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 200);
    }
  }, [location]);

  return (
    <div className="about-genel">
      <div className="about-container">
        {/* 📌 HİKAYE */}
        <section id="fullamoda" className="about-section">
          <h2>BİZİM HİKAYEMİZ</h2>
          <p>   1998 yılında heyecanlı bir yolculuğa başladık. Bu yolculukta her zaman farklı yönlerimizi keşfettik ve en önemlisi, değişimden vazgeçmedik. Kendimizi dünyanın değişen hızına, sürekli yenilenen beklentilere göre şekillendirdik; çünkü Fulla Moda ailesi olarak insana değer vermek, özen göstermek, kıymetli olduğunu hissettirmek bizim ilk önceliğimiz. Yıllardır sizlerin beklentilerini göz önünde bulundurarak kendimizi yeniliyoruz. Siz günlük hayatın temposu içinde koştururken, biz sizi yansıtan, her zaman iyi hissettiren kıyafetlerle hizmet kalitemizden ödün vermiyoruz. Yurt dışında 4 ülkede faaliyet gösteriyoruz. Türkiye’deki 85 mağazamız, online alışveriş ağımız ve binlerce çalışanımızla, siz iyi hissedin diye yaşamınızda yer buluyoruz.</p>
        </section>

        {/* 📌 VİZYON */}
        <section id="vizyon" className="about-section">
          <h2>VİZYONUMUZ</h2>
          <p>Bulunduğumuz her yerde, en kolay ulaşılabilen ve en çok tercih edilen marka olmak.</p>
        </section>

        {/* 📌 MİSYON */}
        <section id="misyon" className="about-section">
          <h2>MİSYONUMUZ</h2>
          <p>Fulla Moda olarak misyonumuz tüm kategorilerde mümkün olan en kaliteli ürünleri, en uygun fiyatlarla ve en geniş  seçenek yelpazesiyle müşterilerimize ulaştırmak, akılda kalıcı bir alışveriş deneyimi yaşatmaktır.</p>
        </section>


        {/* 📌 İLETİŞİM */}
        <section id="iletisim" className="about-section iletisim-section">
          <h2>İLETİŞİM</h2>

          <div className="iletisim-item">
            <strong>Adres:</strong>
            <span>Bahcekapı Mh. 2458. Sk. No: 1 Sasmaz-Etimesgut/ANKARA</span>
          </div>

          <div className="iletisim-item">
            <strong>Telefon:</strong>
            <a href="tel:+9008504400006">+90 850 440 00 06</a>
          </div>

          <div className="iletisim-item">
            <strong>Email:</strong>
            <a href="mailto:info@fullamoda.com">info@fullamoda.com</a>
          </div>

          <iframe
            title="Fulla Moda Konum"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3067.127478043731!2d32.7046278!3d39.9459952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d337e640f6dd75%3A0x66e27656702f14b6!2sFullamoda%20%C4%B0stanbul%20Yolu!5e1!3m2!1str!2str!4v1715860540772!5m2!1str!2str"
            width="100%"
            height="250"
            style={{ border: 0, borderRadius: "10px", marginTop: "10px" }}
            allowFullScreen
            loading="lazy"
          ></iframe>
        </section>

      </div>
    </div>
  );

};

export default About;
